var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "currentColor",
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 8.023a.434.434 0 0 1-.604 0 .402.402 0 0 1 0-.578l3.066-2.96H.423A.414.414 0 0 1 0 4.075c0-.227.187-.414.423-.414h10.12L7.475.706a.409.409 0 0 1 0-.583.434.434 0 0 1 .605 0l3.792 3.66c.17.158.17.421 0 .579L8.081 8.023Z"
  })));
};
export default SvgArrowRight;